export default function getEmptyQuantities(sizeSettings) {
  const numberOfSizes = sizeSettings ? sizeSettings.options.length : 0;
  return new Array(numberOfSizes).fill(0);
}